import Moderator from '@/models/bread/Moderator/book'

export default {
  key:'Book',
  server:'game',
  name:{
    singular:'Book',
    plural:'Books',
  },
  parents:[],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}